import Container from '@components/container/container.view';

export default Container;
